"use client";

import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function LookbookGalleryConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {[...Array(12)].map((_, i) => <div key={i} data-index={i} className="aspect-[3/4] animate-pulse rounded-lg bg-muted/30" style={{
        gridRowEnd: i % 3 === 0 ? "span 2" : "span 1"
      }} />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center gap-4 py-12">
        <p className="text-sm text-muted-foreground">No se pudieron cargar las categorías.</p>
        <Button variant="outline" size="sm" onClick={refetch}>
          Reintentar
        </Button>
      </div>;
  }
  if (terms.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground">No hay categorías disponibles.</p>
      </div>;
  }
  return <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {terms.map((term, i) => <div key={term.id} data-index={i} className="group relative overflow-hidden rounded-lg" style={{
      gridRowEnd: i % 3 === 0 ? "span 2" : "span 1"
    }}>
          {term.image_url && <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" loading="lazy" />}
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-secondary/5 opacity-0 backdrop-blur-[2px] transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:opacity-100">
            <h3 className="mb-3 px-4 text-center font-display text-lg font-semibold tracking-tight text-foreground">
              {term.name}
            </h3>
            {term.link && <Link to={term.link}>
                <Button variant="outline" size="sm" className="bg-white/90 text-foreground shadow-medium backdrop-blur-sm hover:bg-white">
                  Ver Look
                </Button>
              </Link>}
          </div>
        </div>)}
    </div>;
}
export default function LookbookGallery() {
  return <section id="lookbook-gallery" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-semibold tracking-tight text-foreground md:text-5xl">
            Lookbook
          </h2>
          <p className="mt-4 text-muted-foreground">
            Explora nuestras colecciones editoriales
          </p>
        </div>
        <EcommerceTermsProvider taxonomy="product_cat" wp_term_query={{
        per_page: 12,
        order: "desc",
        orderby: "count"
      }} term_fields={["id", "name", "slug", "image_url", "link"]} className="lookbook-gallery-provider">
          <LookbookGalleryConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}